import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/egreso/getEgresos.php';

export default function getEgresos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}